<template>
    <LayoutSub className="personnel">
        <SubSection class="pers_section">
            <div class="title_wrap">
                <h2>
                    역량을 마음껏 발휘할 수 있는 선진화된 인사제도<br />
                    한국정보통신은 <strong class="c-red">공정한 인사평가</strong>와 <strong class="c-red">합리적인 보상체계</strong>를 통해<br />
                    만족도 높은 업무환경을 제공합니다.
                </h2>
            </div>
            
        </SubSection>
            <div class="list_area">
                <ul>
                    <li :class="{active: activeSection === 'section01'}" @click="scrollToSection('section01')">인사정책</li>
                    <li :class="{active: activeSection === 'section02'}" @click="scrollToSection('section02')">직급체계</li>
                    <li :class="{active: activeSection === 'section03'}" @click="scrollToSection('section03')">승격제도</li>
                    <li :class="{active: activeSection === 'section04'}" @click="scrollToSection('section04')">평가제도</li>
                    <li :class="{active: activeSection === 'section05'}" @click="scrollToSection('section05')">복리후생</li>
                </ul>
            </div>
                <section id="section01" class="section01" data-aos="fade-up">
                    <div class="inner">
                        <div class="info">
                            <h2 class="title">인사정책</h2>
                            <p class="txt">도전적인 목표의식과 기업가적인 추진력으로 가치 있는 성과를 주도적으로 창출하는 인재</p><!--v-if-->
                            <div class="img_box">
                                <img src="@/assets/personnel_img01.png" alt="인사정책">
                            </div>
                        </div>
                    </div>
                </section>
                <section id="section02" class="section02" data-aos="fade-up">
                    <div class="inner">
                        <div class="info">
                            <h2 class="title">직급체계</h2>
                            <p class="txt">직급과 직책의 분리운영으로 능력 위주의 직책 보임(직급에 상관없이 팀장 임명)</p>
                            <div class="circle_wrap">
                                <ul>
                                    <li>
                                        <div class="circle">
                                            <strong>K5 매니저</strong>
                                            <p>연구원</p>
                                        </div>
                                        <div class="dot_wrap">
                                            <span class="dot"></span>
                                            <span class="dot"></span>
                                            <span class="dot"></span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="circle">
                                            <strong>K4 매니저</strong>
                                            <p>주임연구원</p>
                                        </div>
                                        <div class="dot_wrap">
                                            <span class="dot"></span>
                                            <span class="dot"></span>
                                            <span class="dot"></span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="circle">
                                            <strong>K3 매니저</strong>
                                            <p>선임연구원</p>
                                        </div>
                                        <div class="dot_wrap">
                                            <span class="dot"></span>
                                            <span class="dot"></span>
                                            <span class="dot"></span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="circle">
                                            <strong>K2 매니저</strong>
                                            <p>책임연구원</p>
                                        </div>
                                        <div class="dot_wrap">
                                            <span class="dot"></span>
                                            <span class="dot"></span>
                                            <span class="dot"></span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="circle">
                                            <strong>K1 매니저</strong>
                                            <p>수석연구원</p>
                                        </div>
                                        <div class="ring"></div>
                                        <div class="ring"></div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="section03" class="section03" data-aos="fade-up">
                    <div class="inner">
                        <div class="info">
                            <h2 class="title">승격제도</h2>
                            <p class="txt">직급별 체류연한을 충족한 자 중 승진 심사를 통한 정규 승진(연1회)<br>성과와 역량이 우수한 구성원의 과감한 발탁 승격</p>
                        </div>
                    </div>
                </section>
                <section id="section04" class="section04" data-aos="fade-up">
                    <div class="inner">
                        <div class="info">
                            <h2 class="title">평가제도</h2>
                            <p class="txt">한국정보통신은 KPI(Key Performance Indicatior)를 통한 부서별 성과평가와 공통/리더십/직무영역에
                                대한<br>개인별 역량평가를 실시하여 공정하고 객관적인 평가체계를 구축하고 있습니다.</p><!--v-if--><!--v-if-->
                            <div class="table_wrap">
                                <table class="tbl">
                                    <colgroup>
                                        <col style="width:15%;">
                                        <col style="width:*;">
                                        <col style="width:15%;">
                                        <col style="width:15%;">
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>구분</th>
                                            <th>평가 내용</th>
                                            <th>평가주기</th>
                                            <th>평가자</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>부서별 성과평가</td>
                                            <td>당해 연도 부서 목표 대비 실적 및 달성도에 따른 성과 평가</td>
                                            <td>연 2회</td>
                                            <td>대표이사</td>
                                        </tr>
                                        <tr>
                                            <td>개인별 성과평가</td>
                                            <td>평가 대상 기간 내 개인별 행동 요소 및 직무 역량 등을 반영한 평가항목에 따른 개인 역량 평가</td>
                                            <td>연 1회</td>
                                            <td>부서장</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="section05" class="section05" data-aos="fade-up">
                    <div class="inner">
                        <div class="info">
                            <h2 class="title">복리후생</h2>
                            <p class="txt">한국정보통신은 구성원들의 삶의 질 향상을 위해 복리후생을 강화하고 있습니다</p>
                            <div class="table-2grid">
                                <TableRow_2grid :title="`4대보험 지원`" :content="`국민연금, 건강보험, 고용보험, 산재보험`"
                                    :src="`sub02_icon01.png`" />
                                <TableRow_2grid :title="`건강관리 지원`" :content="`매년 종합건강검진 실시(배우자 포함)`"
                                    :src="`sub02_icon02.png`" />
                                <TableRow_2grid :title="`경조사 지원`" :content="`경조 휴가 및 경조금 지급`" :src="`sub02_icon03.png`" />
                                <TableRow_2grid :title="`장기근속사원 포상`" :content="`근속 10년/20년별 장기 근속에 대한 포상금 지원`"
                                    :src="`sub02_icon04.png`" />
                                <TableRow_2grid :title="`학자금 지원`" :content="`자녀 학자금 지원(중학교/고등학교/대학교)`"
                                    :src="`sub02_icon05.png`" />
                                <TableRow_2grid :title="`자기개발 지원`" :content="`어학교육비 지원`" :src="`sub02_icon06.png`" />
                                <TableRow_2grid :title="`콘도 이용`" :content="`전국 단위 콘도 체인 이용 시 회원가 적용`"
                                    :src="`sub02_icon07.png`" />
                                <TableRow_2grid :title="`상해보험 지원`" :content="`재직 기간 동안 임직원 단체상해보험 가입`"
                                    :src="`sub02_icon08.png`" />
                                <TableRow_2grid :title="`기타 복지`" :content="`동호회 활동 지원 등`" :src="`sub02_icon09.png`" />
                            </div>
                        </div>
                    </div>
                </section>
    </LayoutSub>
</template>
<script>
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';
import TableRow_2grid from '@/components/TableRow_2grid.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
        TableRow_2grid
    },
    data() {
        return {
            activeSection: "",
        };
    },
    methods: {
        handleScroll() {
            const sections = ["section01", "section02", "section03", "section04", "section05"];
            for (let id of sections) {
                const section = document.getElementById(id);
                const rect = section.getBoundingClientRect();
                if (rect.top >= 0 && rect.top <= window.innerHeight / 2) {
                    this.activeSection = id;
                    break;
                }
            }
        },
        scrollToSection(sectionId) {
            const section = document.getElementById(sectionId);
            section.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        },
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll);
        this.handleScroll();
    },
    beforeUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    },
}
</script>